export { VpPluginFontFamilySelect } from './VpPluginFontFamilySelect';



// WEBPACK FOOTER //
// ./src/vp-ui/form-fields/plugin-details/VpPluginFontFamilySelect/index.js